import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-navy-mid px-5 py-12 sm:py-20" data-id="element-143" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-144" data-mp="22jc1v80aua4w">
        <span className="mb-5 inline-block rounded-full border border-gold/60 bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold" data-id="element-145" data-mp="2gewmc7vof0ef">
          📦 What&apos;s included in the system
        </span>
        <h2 className="font-display text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-146" data-mp="2bltqtu7c9gvl">
          The ESL Survival Vault™
        </h2>
        <p className="mt-5 text-base font-medium text-gold sm:text-lg" data-id="element-147" data-mp="2zaw5qual8vme">
          An all-in-one digital teaching system for ESL &amp; EFL teachers worldwide.
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-gold/60" data-id="element-148" data-mp="uf5jmagshmjx" />
        <p className="mt-6 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-149" data-mp="udkpglye05ml">
          420+ pages of ready-to-use content, organized into 6 teaching volumes and 4 specialized
          bonuses across A1, A2, and B1 levels. Designed to help you teach every class with more
          structure, confidence and impact.
        </p>
      </motion.div>
    </section>;
}